module.exports = __webpack_public_path__ + "media/images/sp/stores/funabashi/access/chiba_funabashi_point1_1-242229f9103c3aecb0fc49afea067c6d.jpg";